import { render, staticRenderFns } from "./ArchivedRewards.vue?vue&type=template&id=522cf3e5&"
import script from "./ArchivedRewards.vue?vue&type=script&lang=js&"
export * from "./ArchivedRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports